import template from './currency.all.html';
import controller from './currency.all.controller';
import './currency.all.scss';

let currencyAllComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template,
  controller
};

export default currencyAllComponent;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/currency/all/currency.all.component.js